var ServiceItem = (props) => {
    return (
        <div className="bg-white p-8 rounded-lg shadow-xl hover:shadow-2xl transition-shadow duration-300 ease-in-out transform hover:-translate-y-2">
            <div className="text-blue-600 mb-4">
                {props.children}
            </div>
            <h3 className="text-2xl font-semibold text-blue-700 mb-4">{props.Nome}</h3>
            <p className="text-gray-600">
                {props.Descricao}
            </p>
        </div>
    )
}
export default ServiceItem